import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserCog, X } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export function profileIncomplete(user) {
  if (!user || user.role !== "rider") return false;
  return !user.phone || !user.phone_verified || !!user.email_placeholder;
}

export default function ProfileReminder({ className = "" }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);
  if (dismissed || !profileIncomplete(user)) return null;
  const needsPhone = !user.phone || !user.phone_verified;
  const missing = [];
  if (needsPhone) missing.push("verify your phone");
  if (user.email_placeholder) missing.push("add your email");
  return (
    <div className={`flex items-center gap-3 rounded-2xl border border-brand-200 bg-brand-50 p-4 ${className}`} data-testid="profile-reminder">
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand text-white">
        <UserCog className="h-5 w-5" />
      </span>
      <button type="button" onClick={() => navigate("/app/profile")} className="flex-1 text-left" data-testid="profile-reminder-cta">
        <p className="text-sm font-semibold text-ink">{needsPhone ? "Verify your phone number" : "Complete your profile"}</p>
        <p className="text-xs text-ink-soft">Please {missing.join(" and ")} so bookings and WhatsApp updates run smoothly.</p>
      </button>
      <button type="button" onClick={() => setDismissed(true)} className="shrink-0 text-ink-muted hover:text-ink" data-testid="profile-reminder-dismiss" aria-label="Dismiss">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
